<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.87 21.93">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_2643" data-name="Group 2643">
          <g id="Group_2642" data-name="Group 2642">
            <path
              id="Path_906"
              data-name="Path 906"
              class="cls-1"
              d="M10.12,4V1a1,1,0,0,0-.95-1H2.77A2.77,2.77,0,0,0,0,2.77V19.16a2.77,2.77,0,0,0,2.77,2.77H14.1a2.77,2.77,0,0,0,2.77-2.77V7.71a1,1,0,0,0-1-1h-3A2.78,2.78,0,0,1,10.12,4Zm3.21,11.17H8v1.69l-4.64-3.4L8,10.08v1.69h5.34Z"
            />
            <path
              id="Path_907"
              data-name="Path 907"
              class="cls-1"
              d="M16.5,3.85,13,.37A1.45,1.45,0,0,0,12.13,0h-.32V3.56a1.5,1.5,0,0,0,1.5,1.5h3.56V4.74A1.45,1.45,0,0,0,16.5,3.85Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
